import { Blockquote } from 'atoms'
import { ReactNode } from 'react'

export interface Question {
  question: string;
  content: ReactNode;
}

const FAQ: Question[] = []

// FAQ.push({
//   question: ``,
//   content: (
//     <>
//       <p></p>
//     </>
//   )
// })

FAQ.push({
  question: `Wozu brauche ich einen Coach?`,
  content: (
    <>
      <p>
        {`Niemand weiß und kann alles. Denken Sie z.B. an Politiker. Sie alle haben Berater und Coaches. Die Anforderungen sind breit gefächert. Was liegt also näher, als Fachleute zu befragen, wenn die beste Freundin auch nicht weiter weiß?`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Warum habe gerade ich Probleme?`,
  content: (
    <>
      <p>
        {`Problemen zu begegnen ist völlig normal, sie gehören zum Leben einfach dazu. Sie machen den Menschen veränderungsfähig und bieten die Chance, sich neu zu entscheiden. Sie sind Impuls für Entwicklung und persönliches Wachstum. Die Frage ist also nicht, warum gerade sie Probleme haben, sondern warum nur sie sich der Lösung professsionell widmen.`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Was macht der Coach genau?`,
  content: (
    <>
      <p>
        {`Der Coach hört intensiv zu, stellt gezielte Fragen und gibt Feedback. Er entwickelt gemeinsam mit Ihnen neue Handlungsstrategien und klärt Ressourcen. Der Coach hält Sie fokussiert und hilft Ihnen, ihre Ziele zu finden und zu erreichen.`}
      </p>
      <p>
        {`Coachs visieren die Zukunft und die Lösungen an, Therapeuten schauen mit Klienten vor allem in die Vergangenheit und auf die Probleme. Coaching im vorliegenden Sinne ist individuelle und effiziente Lebensberatung.`}
      </p>
      <p>
        {`Ich unterstütze Sie bei der Bewältigung von Veränderungs- und Entwicklungsprozessen.`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Warum dauert das so lange?`,
  content: (
    <>
      <p>
        {`Vergleichen Sie es, wenn Sie möchten, mit dem Bau eines Hauses. Wenn das Fundament stabil angelegt ist, wird kein Sturm das Haus so schnell aus den Angeln heben. Und sollte doch einmal ein Dachziegel kaputt gehen, so ist dieser schnell repariert. Ist das Haus jedoch auf Sand gebaut, kann ein erster Windhauch es zum Einstürzen bringen.`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Coaching am Telefon - funktioniert das?`,
  content: (
    <>
      <p>
        {`Sie werden überrascht sein: Coaching am Telefon ist zuweilen dem so genannten "face to face" Coaching überlegen. Sie konzentrieren sich stärker auf die Sache, werden nicht abgelenkt, formulieren exakter, kommen viel schneller auf das Wesentliche und bewahren sich trotzdem eine gewisse Anonymität. Ganz nebenbei ersparen Sie sich lange Reisewege und Reisekosten und können von einem Ort ihrer Wahl aus anrufen. `}
      </p>
    </>
  )
})

FAQ.push({
  question: `Sollte ich mein Geld und meine Zeit nicht lieber besser investieren?`,
  content: (
    <>
      <p>
        {`Überlegen sie selbst, wo Sie Ihre Ressourcen besser anlegen könnten. Vielleicht fnden Sie den Gedanken verlockend, in Zukunft Kraft und Zeit für immer wiederkehrende Probleme zu sparen.`}
      </p>
      <Blockquote caption="&mdash; Konfuzius">
        {`Wer etwas neues anfangen will, soll es sofort tun, denn eine überwundene Schwierigkeit vermeidet hundert neue."`}
      </Blockquote>
    </>
  )
})

FAQ.push({
  question: `Das kann man doch alles in Büchern lesen. Reicht das nicht?`,
  content: (
    <>
      <p>
        {`Stimmt, es gibt sehr gute Literatur, die Lösungswege aufzeigt für die verschiedensten Lebensbereiche. Doch kein Buch kann ihre ganz persönlichen Themen individuell abbilden. Und genau darum geht es beim Coaching.`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Coachs gibt es wie Sand am Meer, die erzählen doch sowieso alle nur das gleiche. Warum sollte ich mich für sie entscheiden?`,
  content: (
    <>
      <p>
        {`Entscheiden Sie sich nur für mich, wenn Sie ein gutes Gefühl aus dem Erstgespräch mitgenommen haben.`}
      </p>
      <h5>Ihre Vorteile</h5>
      <p>
        {`Sie erhalten ein 1:1 auf Sie zugeschnittenes Coaching, persönlich und effizient. Sie bestimmen das Tempo, den Ort und die Zeit. Sie investieren zielgerichtet und schaffen sich ein solides Lebens-Fundament. Sie treffen auf einen Coach, der die Lebenswirklichkeiten von Frauen aus erster Hand kennt.Sie können sich in Ruhe und ohne Risiko für das Angebot entscheiden. Das erste Coaching-Treffen ist für Sie kostenfrei.`}
      </p>
      <h5>Ihre Vorteile im Telefon-Coaching</h5>
      <p>
        {`Sie sparen wertvolle Zeit, weil keine Anfahrtswege anfallen.Sie werden ortsunabhängig gecoacht und können sich somit für ihre persönliche Wohlfühlumgebung entscheiden.Sie erhalten sich durch das Medium Telefon ein Klima der Anonymität, welches es ihnen vielleicht erleichtert, über ihre Anliegen zu sprechen.`}
      </p>
    </>
  )
})

FAQ.push({
  question: `Was bringt mir das Coaching bei hnen nun?`,
  content: (
    <>
      <p>
        {`Das Coaching unterstützt sie dabei:`}
      </p>
      <ul>
        <li>Konflikte konstruktiv zu lösen</li>
        <li>Krisen zu meistern, schwierige Entscheidungen zu treffen</li>
        <li>selbstbewusst und mutig zu agieren</li>
        <li>Perspektiven zu wechseln</li>
        <li>Standpunkte zu ändern</li>
        <li>Verhandlungsspielräume zu erweitern</li>
        <li>individuelle Stärken weiterzuentwickeln</li>
        <li>berufliches und privates neu auszubalancieren</li>
        <li>zufrieden zu leben und zu genießen</li>
      </ul>
    </>
  )
})

export default FAQ
